import {
    date as dateYup,
    object as objectYup,
    string as stringYup,
    number as numYup,
    boolean as booleanYup,
    ref as refYup,
} from 'yup';
import { passwordRegExp } from '../lib/utils/validation';

export const createValidationSchema = (
    isStateValueAvailable: boolean,
    isCityValueAvailable: boolean,
    captchaEnabled: boolean,
    isKYCRequired: boolean,
    passwordRequired?: boolean
) => {
    const invalidYearAlert = 'Founded year should be between 1900 and ' + new Date().getFullYear();

    const baseSchema = {
        FirstName: stringYup().required('First name is required.'),
        LastName: stringYup().required('Last name is required.'),
        Dob: dateYup()
            .nullable()
            .transform((current, orig) => (orig === '' ? null : current))
            .required('Date of birth is required.'),
        Gender: stringYup().required('Gender is required.'),
        Phone: stringYup()
            .required('Contact number is required and must be 10 digit number.')
            .min(10, 'Contact number must be at least 10 digits.'),
        CityDistrict: isCityValueAvailable ? stringYup().required('City is required.') : stringYup(),
        state: isStateValueAvailable ? stringYup().required('State is required.') : stringYup(),
        country: stringYup().required('Country is required.'),
        PostalCode: stringYup().required('Postal / Zip code is required.'),
        recaptcha: captchaEnabled ? stringYup().nullable().required('Captcha is required.') : stringYup().nullable(),
        HighestEducation: numYup().required('Highest education is required.'),
        InstitutionName: stringYup().required('Institution is required.'),
        GraduationYear: numYup()
            .nullable()
            .integer()
            .label('Graduation Year')
            .when('Graduation Year', (foundedYear, schema) => {
                if (foundedYear) {
                    return schema.min(1900, invalidYearAlert).max(new Date().getFullYear(), invalidYearAlert);
                }
                return schema;
            })
            .required('Graduation year is required.'),
        password: passwordRequired
            ? stringYup()
                  .required('Password is required.')
                  .min(8, 'Password must be in between 8 - 16 characters.')
                  .matches(passwordRegExp, 'Password must match the below conditions.')
            : stringYup(),
        cpassword: passwordRequired
            ? stringYup()
                  .nullable()
                  .oneOf([refYup('password'), null], 'Password and Confirm password must match.')
                  .required('Confirm Password is required.')
            : stringYup(),
    };

    const conditionalFields = {
        ...(isKYCRequired && {
            Aadhar: stringYup()
                .required('Aadhaar is required and must be last 4 digits of your Aadhaar number.')
                .max(19, 'Aadhar number must be at least 4 digits.'),
        }),
    };

    return objectYup().shape({ ...baseSchema, ...conditionalFields });
};
